import { ErrorPage } from "@/components/Error/ErrorPage";
import { FullSizeLoader } from "@/design-system/FullSizeLoader";
import { useSessionUserInitial } from "@/hooks/Network/useSessionUserInitial";

import { useProjectContext } from "./ProjectContext";

/** Ensures self data for this project. Nested scopes never change root language, analytics or onboarding. */
export function SessionUserLoader({ children }: { children: React.ReactNode }): React.ReactNode {
  const { projectId } = useProjectContext();
  const { data: user, error } = useSessionUserInitial(projectId);
  if (!user) {
    return error ? <ErrorPage error={error} /> : <FullSizeLoader withPadding />;
  }

  return children;
}
